import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { ApiService } from '@core/providers/http';
import { RondaDocumentParams } from '@core/models';


@Injectable({
  providedIn: 'root',
})
export class DocumentRondaService {

   private readonly endpoint = '/api/Documento/Ronda';

  constructor( private readonly apiService: ApiService, ) {}
  
  gerarDocumento(params: RondaDocumentParams,): Observable<Blob> {
    const httpParams = this.criarParametros(params);
    return this.apiService.get<Blob>(
      this.endpoint,
      httpParams,
      {
        responseType: 'blob',
      },
    );
  }

  private criarParametros(params: RondaDocumentParams,): HttpParams {
    let httpParams = new HttpParams(); 

      httpParams = httpParams.set('PeriodoEnum', String(params.PeriodoEnum),);

      if(params.DataInicioDe){
        httpParams = httpParams.set('DataInicioDe', params.DataInicioDe,);
      }

      if(params.DataInicioAte){
        httpParams = httpParams.set('DataInicioAte', params.DataInicioAte,);
      }

      if(params.ClienteId){
        httpParams = httpParams.set('ClienteId', String(params.ClienteId),);
      }

      if(params.PostoId){
        httpParams = httpParams.set('PostoId', String(params.PostoId),);
      }

      if(params.TurnoId){
        httpParams = httpParams.set('TurnoId', String(params.TurnoId),);
      }

      if(params.EfetivoId){
        httpParams = httpParams.set('EfectivoId', String(params.EfetivoId),);
      }

      if(params.SomenteEmCurso){
        httpParams = httpParams.set('SomenteEmCurso', String(params.SomenteEmCurso),);
      }

    return httpParams;
    }


    criarUrlDownload( params: RondaDocumentParams, baseUrl: string, ): string {
      const httpParams = this.criarParametros(params);
      return `${baseUrl}${this.endpoint}?${httpParams.toString()}`;
    }
  
}
